import { render, staticRenderFns } from "./Stick.vue?vue&type=template&id=e323aa36&scoped=true&"
import script from "./Stick.vue?vue&type=script&lang=js&"
export * from "./Stick.vue?vue&type=script&lang=js&"
import style0 from "./Stick.vue?vue&type=style&index=0&id=e323aa36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e323aa36",
  null
  
)

export default component.exports